export const SET50 = [
  "ADVANC","AOT","AWC","BANPU","BBL","BCP","BDMS","BEM","BH","BJC",
  "BTS","CBG","CCET","COM7","CPALL","CPF","CPN","CRC","DELTA","EGCO",
  "GPSC","GULF","HMPRO","IVL","KBANK","KKP","KTB","KTC","LH","MINT",
  "MTC","OR","OSP","PTT","PTTEP","PTTGC","RATCH","SCB","SCC","SCGP",
  "TCAP","TIDLOR","TISCO","TLI","TOP","TRUE","TTB","TU","VGI","WHA"
];
// Optional เพิ่มเป็น Set ไว้เช็ค membership เร็วมาก




export const SET100 = [
  "AAV","ADVANC","AEONTS","AMATA","AOT","AP","AURA","AWC","BA","BAM",
  "BANPU","BBL","BCH","BCP","BCPG","BDMS","BEM","BGRIM","BH","BJC",
  "BLA","BTG","BTS","CBG","CCET","CENTEL","CHG","CK","COM7","CPALL",
  "CPF","CPN","CRC","DELTA","DOHOME","EA","EGCO","ERW","GLOBAL",
  "GPSC","GULF","GUNKUL","HANA","HMPRO","ICHI","IRPC","ITC","IVL",
  "JAS","JMART","JMT","JTS","KBANK","KCE","KKP","KTB","KTC","LH","M",
  "MBK","MEGA","MINT","MOSHI","MTC","OR","OSP","PLANB","PR9","PRM",
  "PTT","PTTEP","PTTGC","QH","RATCH","RCL","SAWAD","SCB","SCC","SCGP",
  "SIRI","SISB","SJWD","SPALI","SPRC","STA","STGT","TASCO","TCAP",
  "TFG","TIDLOR","TISCO","TLI","TOA","TOP","TRUE","TTB","TU","VGI",
  "WHA","WHAUP"
];


export const SSET = [
  "A5","AAI","ADVICE","AH","AIT","ASIAN","ASK","ASP","BAFS","BBGI",
  "BEC","BLAND","BLC","BRR","CHAYO","COCOCO","DITTO","DMT","DUSIT",
  "EASTW","EKH","EPG","ETC","FM","FORTH","GABLE","GFPT","HENG","HFT",
  "HTC","HUMAN","III","ILINK","ILM","INET","KAMART","KBS","KCG","KGI",
  "KISS","LANNA","LPN","MAJOR","MALEE","MASTER","MC","MCOT","MCS",
  "MEDEZE","MFEC","NCAP","NEO","NER","NOBLE","NSL","NYT","OKJ","ONEE",
  "ORI","PCE","PHG","PLUS","PM","PRTR","PSH","PSL","PSP","PT","PTG",
  "PTL","RABBIT","RBF","RJH","ROJNA","RPH","SABINA","SAFE","SAK",
  "SAMART","SAMTEL","SAPPE","SAT","SC","SCAP","SCGD","SFLEX","SHR",
  "SINGER","SIS","SKY","SNC","SNNP","SPA","SPCG","SSP","STECON",
  "STELLA","STPI","SUN","SUPER","SUSCO","SYNEX","TEAMG","TEGH",
  "THANI","THCOM","THG","TIPCO","TIPH","TKN","TKS","TMAN","TQM",
  "TTA","UVAN","VIH","WPH","XPG"
];


export const MAI = [
  "APO","AU","CFARM","JCKH","KASET","MAGURO","NTSC","TACC","TMILL",
  "WINNER","88TH","DOD","ECF","EFORL","EURO","HPT","ITTHI","JSP",
  "JUBILE","LTS","MGI","MOONG","NPK","NUT","SEI","SKIN","SMD100",
  "WARRIX","AIRA","ASN","BTC","GCAP","KCC","LIT","MITSIB","SGF",
  "TQR","ADB","BPS","CHO","CHOW","CIG","FPI","GTB","KCM","KJL",
  "KUMWEL","KWM","MBAX","MGT","MTW","NDR","PACO","PDG","PHOL","PIMO",
  "PMC","PPM","PRAPAT","RWI","SAF","SALEE","SANKO","SCL","SFT","STP",
  "SWC","TATG","TMC","TMI","TMW","TPLAS","TRT","TRV","UBIS","UEC",
  "UKEM","UREKA","YUASA","ZIGA","ARIN","ARROW","BC","BKA","BLESS",
  "BTW","CAZ","CHEWA","CPANEL","CRD","DHOUSE","DIMET","DPAINT",
  "EMPIRE","FLOYD","HYDRO","IND","JAK","MMM","PANEL","PPS","PRI",
  "QTCG","SENX","SK","SMART","STX","SVR","TAPAC","THANA","TIGER",
  "TITLE","WELL","ABM","ALPHAX","GTV","PSTC","PTC","SAAM","SR",
  "TPCH","UMS","ADD","AKP","ATP30","BIS","BOL","CEYE","CMO","D",
  "DEXON","DV8","ETE","FVC","GFC","GLORY","IMH","IROYAL","IVF",
  "JPARK","KGEN","KK","KOOL","KTMS","LDC","LEO","LTMH","MCA",
  "MOTHER","MPJ","MVP","NCL","NCP","NEWS","PEER","PICO","PLT",
  "QLT","SONIC","THMUI","TNDT","TNH","TNP","TPL","TURTLE","TVDH",
  "TVT","UBA","VL","VS","WASH","YGG","APP","BE8","BVG","COMAN",
  "IDG","IRCP","ITNS","NETBAY","PLANET","READY","SECURE","SICT",
  "SIMAT","SPVI","SRS","TERA","TPS","VCOM"
];


export const SET50_SET = new Set(SET50)
export const SET100_SET = new Set(SET100)
export const SSET_SET = new Set(SSET)
export const MAI_SET = new Set(MAI)

export const ALL_TH_STOCKS = [
  ...SET50,
  ...SET100,
  ...SSET,
  ...MAI,
]

export const ALL_TH_STOCKS_SET = new Set(ALL_TH_STOCKS)

/* ✅ export map ให้ใช้สะดวก */
export const STOCK_GROUP_MAP = {
  ALL: ALL_TH_STOCKS_SET,
  SET50: SET50_SET,
  SET100: SET100_SET,
  SSET: SSET_SET,
  MAI: MAI_SET,
} as const

export type StockGroupKey = keyof typeof STOCK_GROUP_MAP
